/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import SiteAddress from 'components/SiteAddress/SiteAddress';

import styles from '../../../../ActionDrawer.module.scss';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import type { AssignOrChangeUserLocationProps } from '../AssignOrChangeUserLocation';

type InjectedProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AssignOrChangeUserLocationSuccess extends ComponentWithInjectedProps<
  AssignOrChangeUserLocationProps,
  {},
  InjectedProps
> {
  get siteName() {
    const response: Object = this.props.response;
    const names: Array<string> = [response.location.site.name];

    if (response.location.building.name) {
      names.unshift(response.location.building.name);
    }

    if (response.location.room.name) {
      names.unshift(response.location.room.name);
    }

    if (response.location.workspace.name) {
      names.unshift(response.location.workspace.name);
    }

    return names.join(', ');
  }

  render() {
    const { t, response, actionDrawerStore } = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>{t('general:users.location_changed')}</h3>
            <p>{t('general:users.messages.location_changed')}</p>
            <SiteAddress {...response.location.site.address} siteName={this.siteName} />
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
